import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { BaseQuestionAnswerComponent } from '../../../bases';
import { AnswerSectionTitle } from '../../../bases/common';
import { useQuestionContext } from '../../../core';
import { SpeakingAnswerRecorder } from './components';
import { SpeakingSettingsBadgesComponent, SpeakingSubmissionArea } from '../common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SpeakingAnswerContent = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n"])), getSize('padding16'));
export var SpeakingAnswerComponent = function SpeakingAnswerComponent(_ref) {
  var _ref2, _states$attemptCount, _speakingAnswer$value, _speakingAnswer$value2;

  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var speakingQuestion = question;
  var settings = states.speakingSettings || speakingQuestion.speakingSettings;
  var label = states.speakingLabel;
  var speakingAnswer = states.speakingAnswer;
  var currentAttempts = (_ref2 = (_states$attemptCount = states.attemptCount) !== null && _states$attemptCount !== void 0 ? _states$attemptCount : speakingAnswer === null || speakingAnswer === void 0 ? void 0 : speakingAnswer.attemptCount) !== null && _ref2 !== void 0 ? _ref2 : 0;
  var hasSubmittedValue = Boolean(speakingAnswer === null || speakingAnswer === void 0 ? void 0 : (_speakingAnswer$value = speakingAnswer.value) === null || _speakingAnswer$value === void 0 ? void 0 : (_speakingAnswer$value2 = _speakingAnswer$value.audioFile) === null || _speakingAnswer$value2 === void 0 ? void 0 : _speakingAnswer$value2.url);
  var speakingOperation = states.speakingOperation;
  var isSubmitting = ['uploading', 'uploadSucceeded', 'updating'].includes((speakingOperation === null || speakingOperation === void 0 ? void 0 : speakingOperation.stage) || '');
  return /*#__PURE__*/_jsx(BaseQuestionAnswerComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsxs(SpeakingAnswerContent, {
      children: [/*#__PURE__*/_jsx(SpeakingSettingsBadgesComponent, {
        settings: settings,
        label: label,
        currentAttempts: currentAttempts,
        isAnswerMode: true
      }), states.label.yourAnswer && /*#__PURE__*/_jsx(AnswerSectionTitle, {
        children: states.label.yourAnswer
      }), speakingAnswer && hasSubmittedValue && (speakingOperation === null || speakingOperation === void 0 ? void 0 : speakingOperation.stage) !== 'updating' ? /*#__PURE__*/_jsx(SpeakingSubmissionArea, {
        answer: speakingAnswer,
        label: label,
        variant: "answer"
      }) : /*#__PURE__*/_jsx(SpeakingAnswerRecorder, {
        settings: settings,
        label: label,
        onSubmit: function onSubmit(value, audioBlob) {
          var _actions$handleUpdate;

          return (_actions$handleUpdate = actions.handleUpdateSpeakingAnswer) === null || _actions$handleUpdate === void 0 ? void 0 : _actions$handleUpdate.call(actions, value, audioBlob);
        },
        onAttempt: actions.handleCreateSpeakingAnswerAttempt,
        attemptCount: currentAttempts,
        disabled: states.disabled,
        isSubmitting: isSubmitting,
        operation: speakingOperation
      })]
    })
  });
};